import React, { useState } from "react"
import { SlideBar } from "../slide-bar/SlideBar"
import "./defaultLayout.css"
import { TopBar } from "../top-bar/TopBar"
import { Footer } from "../footer/Footer"

const DefaultLayout = ({ children }) => {
  const [toggle, setToggle] = useState(true)

  return (
    <div className="full">
      <SlideBar />
      <div className={toggle ? "main" : "main extended"}>
        <div>
          <TopBar />
          <div className="content">{children}</div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default DefaultLayout
